import { render } from "./AssignBaGroup.vue?vue&type=template&id=7e64a138"
import script from "./AssignBaGroup.vue?vue&type=script&lang=js"
export * from "./AssignBaGroup.vue?vue&type=script&lang=js"

import exportComponent from "/www/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__